import axios from "axios";
import * as endpoints from "./const";
import querystring from "querystring";

class NotificationApi {
	static fetchNotificationSettings() {
		return axios
			.get(`${endpoints.NOTIFICATION_SETTINGS}`)
			.then(response => response.data.data)
			.then(data => {
				return data;
			})
			.catch(error => {
				throw error;
			});
	}

	static setPortalNotification(data) {
		return axios
			.post(`${endpoints.NOTIFICATION_SETTINGS}`, data)
			.then(response => response.data.data)
			.then(data => {
				return data;
			})
			.catch(error => {
				throw error;
			});
	}

	static setEmailNotification() {
		return axios
			.post(`${endpoints.NOTIFICATION_SETTINGS}`)
			.then(response => response.data.data)
			.then(dataUpdatedEmail => {
				return dataUpdatedEmail;
			})
			.catch(error => {
				throw error;
			});
	}

	static deleteNotification(data) {
		return axios
			.post(`${endpoints.NOTIFICATION_DELETE}`, data)
			.then(response => response.data)
			.then(data => {
				console.log(data);
				return data;
			})
			.catch(error => {
				throw error;
			});
	}

	static getAllNotifications() {
		return axios
			.get(endpoints.GET_NOTIFICATIONS)
			.then(response => response.data)
			.then(data => data)
			.catch(error => {
				throw error;
			});
	}

	static getSummaryDetail(data) {
		return axios
			.post(endpoints.INSIGHT_SUMMARY_DETAIL, data)
			.then(response => response.data)
			.then(data => {
				return data;
			})
			.catch(error => {
				throw error;
			});
	}

	static getTotalTillDateByKey(
		graphId,
		companyCode,
		countryCode,
		filterKeyId
	) {
		return axios
			.get(
				`${endpoints.INSIGHT_TOTAL_TILL_DATE}?id=${graphId}&companyCode=${companyCode}&countryCode=${countryCode}&filterKeyId=${filterKeyId}`
			)
			.then(response => response.data)
			.then(data => {
				return data;
			})
			.catch(error => {
				throw error;
			});
	}

	static getNotificationDetail(reportParams) {
		return axios
			.get(endpoints.INSIGHT_NOTIFICATION_DETAIL, {
				params: reportParams
			})
			.then(response => response.data)
			.then(data => {
				return data;
			})
			.catch(error => {
				throw error;
			});
	}

	static gridAction(payload, apiInfo) {
		const rootApi = endpoints.getAPIRoot();
		const endpointUrl = apiInfo.ActionUrl;

		switch (apiInfo.HttpMethod) {
			case "POST":
				return axios
					.post(`${rootApi}/notifications/changeStatus`, payload)
					.then(response => response.data)
					.then(data => {
						return data;
					})
					.catch(error => {
						throw error;
					});
		}
	}
}

export default NotificationApi;



// WEBPACK FOOTER //
// ./src/api/NotificationApi.js